// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.divider[data-v-0d276940] {\r\n  width: 80%;\r\n  border-top: 1px solid #464646;\r\n  margin-top: 2rem;\r\n  margin-bottom: 2rem;\n}\r\n\r\n/* h3 { */\n.dark[data-v-0d276940] {\r\n  color: white;\n}\n.light[data-v-0d276940] {\r\n  color: rgb(26, 26, 26);\n}\r\n\r\n/* } */\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
